module.exports = __webpack_public_path__ + "img/organizations_details_border.c9b88cf1.svg";